// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import conversationApi from '~/apis/conversation';
import {
  CREATE_NEW_CONVERSATION,
  CREATE_NEW_MESSAGE,
  GET_LIST_CONVERSATION,
  GET_LIST_MESSAGE,
} from '~/utils/constants/actionType';
import { IQueryParamBase } from '~/utils/interface/common';
import {
  IQueryCreateNewConversation,
  IQueryCreateNewMessage,
  IQueryGetListMessage,
} from '~/utils/interface/conversation';

export const getListConversation = createAsyncThunk(
  GET_LIST_CONVERSATION,
  async (payload: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await conversationApi.getListConversation(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createNewMessage = createAsyncThunk(
  CREATE_NEW_MESSAGE,
  async (payload: IQueryCreateNewMessage, { rejectWithValue }) => {
    try {
      const resp = await conversationApi.createNewMessage(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createNewConversation = createAsyncThunk(
  CREATE_NEW_CONVERSATION,
  async (payload: IQueryCreateNewConversation, { rejectWithValue }) => {
    try {
      const resp = await conversationApi.createNewConversation(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListMessage = createAsyncThunk(
  GET_LIST_MESSAGE,
  async (payload: IQueryGetListMessage, { rejectWithValue }) => {
    try {
      const resp = await conversationApi.getListMessage(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
